import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { CrearFacturaComponent } from './CrearFactura.component';

import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'CrearFactura',
        component: CrearFacturaComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'CrearFactura'
        } 
    }
];

@NgModule({
    declarations: [
        CrearFacturaComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        CrearFacturaComponent
    ],
    bootstrap: [CrearFacturaComponent]
})

export class CreraFacturaModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CrearFactura/CrearFactura.module.ts